export default __webpack_public_path__ + "static/media/guide06.4e6a7aed.png";